export default "__VITE_ASSET__21f9d680__"